var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdminSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#00E2BC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.335 13.016a.933.933 0 1 0 0-1.867.933.933 0 0 0 0 1.867Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.335 13.75c-.609 0-1.825.3-1.867.9.417.591 1.1.974 1.867.974.766 0 1.45-.383 1.866-.975-.041-.6-1.258-.9-1.866-.9Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.168 8.408V4.39l-6.25-2.725-6.25 2.725v4.092c0 3.783 2.667 7.325 6.25 8.183.458-.108.9-.267 1.333-.458a4.977 4.977 0 0 0 4.084 2.125c2.758 0 5-2.242 5-5 0-2.475-1.8-4.525-4.167-4.925Zm-5.833 4.925c0 .466.066.925.191 1.35-.2.091-.4.183-.608.25-2.642-.834-4.583-3.534-4.583-6.45v-3l4.583-2 4.583 2v2.925a4.998 4.998 0 0 0-4.166 4.925Zm5 3.333a3.332 3.332 0 1 1 0-6.667 3.332 3.332 0 1 1 0 6.667Z"
}))));
export default SvgAdminSettings;